import { Injectable } from "@angular/core";
import {
    ConnectionBackend, Headers, Http, Request, RequestMethod, RequestOptions, RequestOptionsArgs,
    Response, URLSearchParams
} from "@angular/http";
import { AuthService, TokenManager } from "../../+login/auth.service";
import { Observable } from "rxjs/Observable";
import { isNullOrUndefined } from "util";
import { RequestConfig } from "../../shared/rest/rest.request";
import { environment } from "../../../environments/environment";
import { ErrorResponse } from "./error.response";
import { Subject } from "rxjs/Subject";
import { NotificationService } from "../../shared/utils/notification.service";


@Injectable()
export class CustomHttp extends Http {
    private customApiUrl: string;

    constructor(_backend: ConnectionBackend,
        _defaultOptions: RequestOptions,
        public oauth: AuthService,
        public notificationService: NotificationService) {
        super(_backend, _defaultOptions);
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        //Se agrego if para quitar hier_token y bearer token a peticiones que van a los servicios de mule para mandar solo el Basic Authentication
        if (this.isSecure(options) &&
            (
                url.toString().includes(environment.MEGA_API_URL) ||
                url.toString().includes(environment.API_MEGA) ||
                url.toString().includes(environment.API_MEGA_2) ||
                url.toString().includes(environment.API_SFYC) ||
                url.toString().includes(environment.MEGA_API_URL2) ||
                url.toString().includes(environment.MEGA_API_URL_VENTAS) ||
                url.toString().includes(environment.Mega_url))
            ) 
        {
            options.headers.delete('Authorization');
            options.headers.delete('Hier_token');
        }

        if (this.isSecure(options)) {
            if (this.oauth.isTokenValid()) {
                console.log(url + '-' + options)
                if (url.toString().search('/users/') >= 0 || url.toString().search('notification/') >= 0 || 
                url.toString().search('/tickets/ultimos5-dash') >= 0 || url.toString().search('priority-catalog') >= 0 
                || url.toString().search('groups/all') >= 0) {   
                } else {
                    
                    try {
                        let infoUserLogger = JSON.parse(localStorage.getItem('info_user_logged'));
                        console.log(infoUserLogger)
                        if (infoUserLogger.userAppView) {
                            console.log(infoUserLogger)
                        }
                    } catch (error) {
                        console.log(error)
                        this.oauth.logout();
                        return;
                    }
                }
                return super.request(url, options).catch(error => Observable.throw(error));
            }
            return this.oauth.refreshToken()
                .flatMap((success: TokenManager) => {
                    options.headers.set("Authorization", success.token_type + " " + success.access_token);
                    return super.request(url, options);
                }).catch(error => this.handleError(error));
        } else {
            const basicAuth = environment.BASIC_AUTH_CREDENTIALS;
            options.headers.append('Authorization', 'Basic ' + btoa(basicAuth));
            return super.request(url, options).catch(error => Observable.throw(error));
        }
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        if (this.isSecure(options)) {
            if (this.oauth.isTokenValid())
                return super.get(url, options).catch(error => Observable.throw(error));
            return this.oauth.refreshToken()
                .flatMap((success: TokenManager) => {
                    options.headers.set("Authorization", success.token_type + " " + success.access_token);
                    return super.get(url, options);
                }).catch(error => Observable.throw(error));
        }
        return super.get(url, options).catch(error => Observable.throw(error));
    }

    /**
     * Performs a request with `post` http method.
     */
    post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        if (this.isSecure(options)) {
            if (this.oauth.isTokenValid())
                return super.post(url, options).catch(error => Observable.throw(error));
            return this.oauth.refreshToken()
                .flatMap((success: TokenManager) => {
                    options.headers.set("Authorization", success.token_type + " " + success.access_token);
                    return super.post(url, options);
                }).catch(error => Observable.throw(error));
        }
        return super.post(url, options).catch(error => Observable.throw(error));
    }

    /**
     * Performs a request with `put` http method.
     */
    put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        if (this.isSecure(options)) {
            if (this.oauth.isTokenValid())
                return super.put(url, options).catch(error => Observable.throw(error));
            return this.oauth.refreshToken()
                .flatMap((success: TokenManager) => {
                    options.headers.set("Authorization", success.token_type + " " + success.access_token);
                    return super.put(url, options);
                }).catch(error => Observable.throw(error));
        }
        return super.put(url, options).catch(error => Observable.throw(error));
    }

    /**
     * Performs a request with `delete` http method.
     */
    delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
        if (this.isSecure(options)) {
            if (this.oauth.isTokenValid())
                return super.delete(url, options).catch(error => Observable.throw(error));
            return this.oauth.refreshToken()
                .flatMap((success: TokenManager) => {
                    options.headers.set("Authorization", success.token_type + " " + success.access_token);
                    return super.delete(url, options);
                }).catch(error => Observable.throw(error));
        }
        return super.delete(url, options).catch(error => Observable.throw(error));
    }


    /**
     * Método para enviar peticiones al servidor
     * @param config configuración necesaria para enviar la petición
     * @param token OAUTH2 para enviar peticiones seguras
     * @param body información a enviar el servidor
     * @param pathVariables valores que se reemplazaran en la URI
     * @return  Observable<Response>
     */
    sendRequest(config: RequestConfig, body?: any, ...pathVariables): Observable<Response> {
        let options: RequestOptions = new RequestOptions();
        //agregar los parametros que se necesitan al request
        if (!isNullOrUndefined(body)) {
            if (config.method != RequestMethod.Get) options.body = body;
            else {
                options.search = new URLSearchParams();
                for (var prop in body) {
                    options.search.append(prop, body[prop]);
                }
            }
        }

        options.method = config.method;
        //configuración de headers de request
        options.headers = new Headers();
        options.headers.append('Content-Type', config.contentType);
        //seguridad oauth si es necesario
        if (config.secure && !isNullOrUndefined(this.oauth.token)) {
            options.headers.append('Authorization', this.oauth.token.token_type + " " + this.oauth.token.access_token);
            options.headers.append("hier_token", this.oauth.token.hier_token);
        }

        let url;

        if (!this.customApiUrl) {
            url = this.getFormattedUrl(environment.api_url + config.uri, pathVariables);
        } else {
            url = this.getFormattedUrl(this.customApiUrl + config.uri, pathVariables);
            this.customApiUrl = "";
        }

        return this.request(url, options);
    }

    sendRequestToUrl(apiUrl: string, config: RequestConfig, body?: any, ...pathVariables): Observable<Response> {
        this.customApiUrl = apiUrl;
        return this.sendRequest(config, body, pathVariables);
    }

    isSecure(options?: RequestOptionsArgs) {
        return !isNullOrUndefined(options) && !isNullOrUndefined(options.headers) && !isNullOrUndefined(options.headers.get('Authorization'));
    }

    private getFormattedUrl(url: string, ...pathVariables) {
        let size = url.indexOf('{');
        if (!isNullOrUndefined(pathVariables) && pathVariables.length > 0 && size > 0) {
            pathVariables.forEach(variable => {
                variable.forEach(path => {
                    let index = url.indexOf('{');
                    let limit = url.indexOf('}') + 1;
                    url = url.substr(0, index) + path + url.substr(limit, url.length);
                });
            });
        }
        return url;
    }

    handleError(error: Response | any) {
        var errorResponse: ErrorResponse;
        if (error instanceof Response) {
            if (error.status == 401) {
                this.oauth._refreshing = new Subject();
                this.oauth.logout();
            }
            const body = error.json();
            errorResponse = body;
        } else {
            if (error.error && (error.error == "invalid_token" || error.error == "invalid_grant")) {
                this.oauth._refreshing = new Subject();
                this.oauth.logout();
            }
            errorResponse = new ErrorResponse("ERRDESC", error.status, "Error al enviar la petición", []);
        }

        switch (errorResponse.status) {
            case 400:
                break;
            case 401:
                break;
            case 500:
                if (this.notificationService) {
                    this.notificationService.bigBox({
                        title: "Error en servicio",
                        content: "No fue posible la petición al servidor debido a un problema con el servicio.",
                        color: "#df295f",
                        icon: "fa fa-warning shake",
                        timeout: 5000
                    });
                }
                break;
            default:
                if (this.notificationService) {
                    // this.notificationService.bigBox({
                    //     title: errorResponse.message || "Error en solicitud",
                    //     content: errorResponse.errorList.length ? errorResponse.errorList[0] : "Error " + (errorResponse.status || "") + " en la solicitud",
                    //     color: "#df295f",
                    //     icon: "fa fa-warning shake",
                    //     timeout: 5000
                    // });
                }
                break;
        }
        return Observable.throw(errorResponse).toPromise();
    }



    /**
     * Método para enviar peticiones al servidor
     * @param config configuración necesaria para enviar la petición
     * @param token OAUTH2 para enviar peticiones seguras
     * @param body información a enviar el servidor
     * @param pathVariables valores que se reemplazaran en la URI
     * @return  Observable<Response>
     */
    sendRequestApiMega(config: RequestConfig, body?: any, ...pathVariables): Observable<Response> {
        let options: RequestOptions = new RequestOptions();
        //agregar los parametros que se necesitan al request
        if (!isNullOrUndefined(body)) {
            if (config.method != RequestMethod.Get) options.body = body;
            else {
                options.search = new URLSearchParams();
                for (var prop in body) {
                    options.search.append(prop, body[prop]);
                }
            }
        }

        options.method = config.method;
        //configuración de headers de request
        options.headers = new Headers();
        options.headers.append('Content-Type', config.contentType);

        //seguridad oauth si es necesario
        if (config.secure && !isNullOrUndefined(this.oauth.token)) {
            options.headers.append('Authorization', this.oauth.token.token_type + " " + this.oauth.token.access_token);
            options.headers.append("hier_token", this.oauth.token.hier_token);
        }

        let url;
        if (!this.customApiUrl) {
            url = this.getFormattedUrl(environment.API_MEGA + config.uri, pathVariables);
        } else {
            url = this.getFormattedUrl(this.customApiUrl + config.uri, pathVariables);
            this.customApiUrl = "";
        }
        return this.request(url, options);
    }

    /**
    * Método para enviar peticiones al servidor de mega 2
    * @param config configuración necesaria para enviar la petición
    * @param token OAUTH2 para enviar peticiones seguras
    * @param body información a enviar el servidor
    * @param pathVariables valores que se reemplazaran en la URI
    * @return  Observable<Response>
    */
    sendRequestApiMega2(config: RequestConfig, body?: any, ...pathVariables): Observable<Response> {
        let options: RequestOptions = new RequestOptions();
        //agregar los parametros que se necesitan al request
        if (!isNullOrUndefined(body)) {
            if (config.method != RequestMethod.Get) options.body = body;
            else {
                options.search = new URLSearchParams();
                for (var prop in body) {
                    options.search.append(prop, body[prop]);
                }
            }
        }

        options.method = config.method;
        //configuración de headers de request
        options.headers = new Headers();
        options.headers.append('Content-Type', config.contentType);
        //seguridad oauth si es necesario
        if (config.secure && !isNullOrUndefined(this.oauth.token)) {
            options.headers.append('Authorization', this.oauth.token.token_type + " " + this.oauth.token.access_token);
            options.headers.append("hier_token", this.oauth.token.hier_token);
        }

        let url;
        if (!this.customApiUrl) {
            url = this.getFormattedUrl(environment.API_MEGA_2 + config.uri, pathVariables);
        } else {
            url = this.getFormattedUrl(this.customApiUrl + config.uri, pathVariables);
            this.customApiUrl = "";
        }

        return this.request(url, options);
    }



}
